import React, { useState, useEffect } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Radio, Input, Typography, Select, Button, message } from 'antd';
import JiraDynamicFieldSelect from '../skill_builder/steps/jiraDynamicFieldSelect';
import BoardSprintSelect from '../skill_builder/steps/boadSprintSelect';
import EpicSelect from '../skill_builder/steps/epic_select';
import NumberField from '../skill_builder/steps/numberFiled';

import { saveCard, updateCard } from '../skill_builder/steps/CardActions';
import { getJiraIssueNodeFields } from '../skill_builder/skillBuilderActions';
import { getProject, getJiraBoards, getFilterFromJira } from '../skills_action';
import {
  getProjectText,
  jqlTemplates,
  getFields,
  errors,
  Daterange,
  getNumberField,
} from '../skill_builder/steps/getProjectText';
import {
  handleSourceDataChange,
  cardInfo,
  handleAppearanceData,
} from './report_actions';
import CustomFilter from './customFilter';
import axios from 'axios';
import { handleFilterJql } from './handleJql';
const { Text, Title } = Typography;
const { Option } = Select;
const { TextArea } = Input;

const SourceDataOptions = (props) => {
  const existingSkill = useSelector((state) => state.report.template);
  let cardInformation = props.report.cardInfo;
  let template = props.card_template_id;
  // /rest/api/3/project/{projectIdOrKey}/statuses
  const dispatch = useDispatch();
  const sortListData = useSelector((state) => state.report.sortListData);
  const [data, setData] = useState({
    ...(existingSkill &&
      existingSkill.cardInformation &&
      existingSkill.cardInformation.cardInformation &&
      existingSkill.cardInformation.cardInformation),
    ...cardInformation,
  });
  const [errors, setErrors] = useState({});
  const [editmode, setEditMode] = useState(false);
  const [jqlLoading, setJqlLoading] = useState(false);
  const [jql, setJql] = useState(
    existingSkill &&
      existingSkill.cardInformation &&
      existingSkill.cardInformation.cardInformation &&
      existingSkill.cardInformation.cardInformation.jql
      ? existingSkill.cardInformation.cardInformation.jql
      : ''
  );
  const [customJql, setCustomJql] = useState('');
  const [loadBoard, setLoadBoard] = useState('');
  const [isCustomJQLTemplate, setIsCustomJQLTemplate] = useState(false);

  const [filterType, setFilterType] = useState(
    (cardInformation && cardInformation.filterType) ||
      (existingSkill &&
        existingSkill.cardInformation &&
        existingSkill.cardInformation.cardInformation &&
        existingSkill.cardInformation.cardInformation.filterType) ||
      'Basic Filter'
  );
  const [JQLfilter, setJQLFilter] = useState('');
  const [timeout, setTIMEOUT] = useState(0);
  const [jqlValidated, setJqlValidated] = useState(
    existingSkill &&
      existingSkill.cardInformation &&
      existingSkill.cardInformation.cardInformation
      ? true
      : false
  );

  const [filterFromJira, setFilterFromJira] = useState(null);
  const [selectedFilterFromJira, setSelectedFilterFromJira] = useState(null);
  const [filterFromJiraError, setFilterFromJiraError] = useState(false);

  const [selectedProjects, setSelectedProjects] = useState([]);
  const [isFieldDisabled, setIsFieldDisabled] = useState(false);
  const [listFilterType, setListFilterType] = useState(
    existingSkill &&
      existingSkill.cardInformation &&
      existingSkill.cardInformation.cardInformation &&
      existingSkill.cardInformation.cardInformation.listFilterType
  );
  const [selectedPreBuiltFilter, setSelectedPreBuiltFilter] = useState(
    existingSkill &&
      existingSkill.cardInformation &&
      existingSkill.cardInformation.cardInformation &&
      existingSkill.cardInformation.cardInformation.selectedPreBuiltFilter
  );

  const [showUpdateFilterModal, setShowUpdateFilterModal] = useState(false);

  const user = useSelector((state) => {
    return state.common_reducer.user;
  });

  // console.log('here ', cardInformation, template)
  useEffect(() => {
    // console.log('sourceData Key', template && template.key);
    if (template) {
      // console.log('sourceData', cardInformation, template);
      if (cardInformation && Object.keys(cardInformation).length > 0) {
        // console.log('======template found , card info found======', cardInformation, template);
        if (
          template &&
          template.key /* &&
        (template.key == 'jira_burn_down_chart' ||
          template.key == 'jira_velocity_chart' ||
          template.key == 'get_issues_by_jql') */
        ) {
          // console.log('======template found');
          // dispatch(cardInfo(cardInformation ? cardInformation : {}));
          setData(cardInformation);
          setSelectedProjects(cardInformation.projects);
          setSelectedPreBuiltFilter(cardInformation.selectedPreBuiltFilter);
          setFilterType(cardInformation.filterType || 'Basic Filter');
          setListFilterType(cardInformation.listFilterType);
          setSelectedFilterFromJira(cardInformation.filterValue);
          setJql(cardInformation.jql);
          let isJqlValid = checkIsJqlValid(
            getProjectText(cardInformation, editmode)
          );
          if (isJqlValid) setJqlValidated(true);
        } else {
          // console.log('=====template not found');

          setData({
            ...(existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation &&
              existingSkill.cardInformation.cardInformation),
            ...cardInformation,
          });
          setSelectedProjects(
            existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation &&
              existingSkill.cardInformation.cardInformation.projects
          );
          setSelectedPreBuiltFilter(
            existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation &&
              existingSkill.cardInformation.cardInformation
                .selectedPreBuiltFilter
          );
          setFilterType(
            existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation &&
              existingSkill.cardInformation.cardInformation.filterType
          );
          setListFilterType(
            existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation &&
              existingSkill.cardInformation.cardInformation.listFilterType
          );
          setJql(
            existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation.jql
          );
          setSelectedFilterFromJira(
            existingSkill &&
              existingSkill.cardInformation &&
              existingSkill.cardInformation.cardInformation.filterValue
          );

          let isJqlValid = checkIsJqlValid(
            getProjectText(
              existingSkill &&
                existingSkill.cardInformation &&
                existingSkill.cardInformation.cardInformation,
              editmode
            )
          );
          if (isJqlValid) setJqlValidated(true);
        }

        //set boards
        if (
          (cardInformation.projects && cardInformation.projects[0]) ||
          cardInformation.project_id
        ) {
          setLoadBoard(true);
          let proj = cardInformation.project_id
            ? cardInformation.project_id
            : cardInformation.projects[0];
          let query = 'projectKeyOrId=' + proj;
          props.getJiraBoards(props.match.params.wId, query).then((res) => {
            setLoadBoard(false);
          });
        }
      } else if (template) {
        // console.log('======template found , card info not found');
        // console.log('sourceData template', cardInformation, template);
        let defaultValuesObj = { ...template.defaultValues };
        setData({ ...data, ...defaultValuesObj });
        setSelectedProjects([]);
        // setData(template.key=='custom_report_2'? null:template.defaultValues);
        setFilterType(
          template.defaultValues && template.defaultValues.filterType
        );
        setListFilterType(
          template.defaultValues && template.defaultValues.listFilterType
        );
        let jqlFromTemplate = getProjectText(
          template.defaultValues,
          props.isEditMode
        );
        setJql(jqlFromTemplate);
      }

      let query = '';

      if (
        template &&
        template.key &&
        (template.key == 'jira_burn_down_chart' ||
          template.key == 'jira_velocity_chart')
      ) {
        props
          .getJiraBoards(props.match.params.wId, 'type=scrum,simple')
          .then((res) => {});
      }

      // console.log('\n\n ==============================')
    }
  }, [template]);

  const checkIsJqlValid = async (jql) => {
    let body = {
      jql: jql,
    };
    return axios
      .post(
        //   "/bot/api/skill/" +
        //     props.match.params.wId +
        //     "/verifyJql/" +
        //     props.match.params.wId,
        `/bot/api/w/${props.match.params.wId}/jira/verifyJql`,
        body
      )
      .then((res) => res);
  };

  const handleJql = (value) => {
    setJqlLoading(true);
    setJql(value);
    if (timeout) clearTimeout(timeout);
    setTIMEOUT(
      setTimeout(() => {
        checkIsJqlValid(value).then((res) => {
          setJqlLoading(false);
          if (res.data.success) {
            setJqlValidated(true);
            setData({
              ...data,
              jql: value,
            });
            dispatch(
              cardInfo({
                ...data,
                jql: value,
              })
            );
          } else {
            setJqlValidated(false);
          }
        });
      }, 300)
    );
  };

  useEffect(() => {
    if (jql) {
      handleJql(jql);
    }
  }, [jql]);

  const jiraSkill = props.skills.find((skill) => skill.key === 'jira');

  let servertype =
    jiraSkill &&
    jiraSkill.skill_metadata &&
    jiraSkill.skill_metadata.metadata &&
    jiraSkill.skill_metadata.metadata.server_type;

  const getOptions = (key) => {
    const children = [];
    if (key === 'get_projects') {
      props.projects.forEach((project, index) => {
        children.push(
          <Option key={index} name={key} value={project.key}>
            {project.name + ` (${project.key})`}
          </Option>
        );
      });
    } else if (key === 'select_JQL_template') {
      jqlTemplates().forEach((template, index) => {
        children.push(
          <Option key={index} name='select_template_jql' value={template.value}>
            {template.name}
          </Option>
        );
      });
    } else if (key === 'user_field') {
      props.userFields &&
        props.userFields.forEach((field, index) => {
          field &&
            field.key &&
            children.push(
              <Option
                key={index}
                name='x-axis-field'
                value={field.id || field.key}
              >
                {field.name}
              </Option>
            );
        });
    } else if (key === 'x-axis-field') {
      let fields = getFields(props.fields, 'x-axis');
      fields.forEach((field, index) => {
        field &&
          field.value &&
          children.push(
            <Option key={field.value} name='x-axis-field' value={field.value}>
              {field.name}
            </Option>
          );
      });
    } else if (key === 'y-axis-field') {
      let fields = getFields(props.fields, 'y-axis');
      fields.forEach((field, index) => {
        field &&
          field.value &&
          children.push(
            <Option key={index} name='y-axis-field' value={field.value}>
              {field.name}
            </Option>
          );
      });
    } else if (key === 'number-field') {
      let fields = getNumberField(props.fields, props.numberFields); //numberFields;

      if (fields.length > 0) {
        fields.forEach((field, index) => {
          children.push(
            <Option key={index} name='number-field' value={field.value}>
              {field.name}
            </Option>
          );
        });
      }
    } else if (key === 'date_range') {
      let range = Daterange();
      range.forEach((field, index) => {
        children.push(
          <Option key={index} name='date_range' value={field.value}>
            {field.name}
          </Option>
        );
      });
    } else if (key === 'board') {
      props.boards.forEach((board, index) => {
        children.push(
          <Option key={index} name='boardId' value={board.id}>
            {board.name + ` (${board.type})`}
          </Option>
        );
      });
    } else if (key == 'project_id') {
      props.projects.forEach((project, index) => {
        children.push(
          <Option key={index} name='project_id' value={project.key}>
            {project.name + ` (${project.key})`}
          </Option>
        );
      });
    } else if (key == 'days' || key == 'jql_days') {
      let daysArr = [
        { name: '1 day', value: 1 },
        { name: '2 days', value: 2 },
        { name: '3 days', value: 3 },
        { name: '4 days', value: 4 },
        { name: '5 days', value: 5 },
        { name: '1 week', value: 7 },
        { name: '2 week', value: 14 },
      ];
      daysArr.forEach((item, index) => {
        children.push(
          <Option key={item.value} name='days' value={item.value}>
            {item.name}
          </Option>
        );
      });
    } else if (key == 'estimation_field') {
      let arr = [
        { name: 'Issue Count', value: 'issueCount_' },

        { name: 'Remaining Time Estimate', value: 'field_timeestimate' },
        {
          name: 'Original Time Estimate',
          value: 'field_timeoriginalestimate',
        },
      ];

      let storyPoint;

      if (data?.board?.type === 'simple') {
        // Only one item
        storyPoint = props.fields.find(
          (item) => item.text === 'Story point estimate' && item.type === 'number'
        );
      
        if (storyPoint && storyPoint.value) {
          let storyPointArr = storyPoint.value.split('.');
          arr.push({
            name: storyPoint.text,
            id: storyPoint.id,
            value: 'field_' + storyPointArr[storyPointArr.length - 1],
          });
        }
      } else {
        // Get up to first 3
        let storyPoints = props.fields.filter(
          (item) => item.text === 'Story Points' && item.type === 'number'
        );
      
        storyPoints.slice(0, 3).forEach((storyPoint) => {
          if (storyPoint.value) {
            let storyPointArr = storyPoint.value.split('.');
            let suffix = storyPoints.length > 1 ? `(${storyPointArr[storyPointArr.length - 1]})` : '';
            arr.push({
              name: `${storyPoint.text}${suffix}`,
              id: storyPoint.id,
              value: 'field_' + storyPointArr[storyPointArr.length - 1],
            });
          }
        });
        
      }

      arr.forEach((item) =>
        children.push(
          <Option key={item.value} value={item.value}>
            {item.name}
          </Option>
        )
      );
    } else if (key == 'listFilter') {
      let arr = [
        { name: 'Pre-built Filter', value: 'prebuilt_filter' },
        { name: 'Custom Filter', value: 'custom_filter' },
        { name: 'JQL filter', value: 'jql_filter' },
        { name: 'Saved Jira Filter', value: 'saved_jira_filter' },
      ];

      arr.forEach((item) => {
        if (
          item.value === 'saved_jira_filter' &&
          servertype &&
          servertype === 'jira_cloud_oauth'
        ) {
          children.push(
            <Option key={item.value} value={item.value}>
              {item.name}
            </Option>
          );
        } else if (item.value !== 'saved_jira_filter')
          children.push(
            <Option key={item.value} value={item.value}>
              {item.name}
            </Option>
          );
      });
    }

    return children;
  };

  const handleChange = (value, type) => {
    if (!value) {
      let objkey = type == 'boardId' ? 'board' : type;
      //  if( type==="select_template_jql")
      // setData({ ...data, [objkey]: null });
      // dispatch(handleSourceDataChange(objkey, value));
      return;
      //  }else {

      //  }
    }
    if (type) {
      if (type == 'projects' || type == 'project_id') {
        let newdata = { ...data };
        newdata.projectInfo = props.projects.find((item) => item.key == value);
        newdata.projects = value;
        newdata.jql = getProjectText(newdata);
        // setLoadBoard(true);

        setSelectedProjects(value);
        setData(newdata);
        dispatch(cardInfo(newdata));
        let proj = type == 'project_id' ? value : value[0];
        let query = 'projectKeyOrId=' + proj;
        // props.getJiraBoards(props.match.params.wId, query).then((res) => {
        //   // setLoadBoard(false);
        // });
      } else if (type === 'custom_jql' || type == 'send_as') {
        let newerrors = errors;
        delete newerrors['custom_jql'];
        setCustomJql(value.target.value);
        setData({ ...data, [type]: value.target.value });
        dispatch(cardInfo({ ...data, [type]: value.target.value }));
        setErrors({ ...newerrors });
      } else if (type === 'select_template_jql') {
        let newerrors = errors;
        delete newerrors['type'];

        setData({
          ...data,
          custom_jql: value,
          select_template_jql: value,
        });
        dispatch(
          cardInfo({
            ...data,
            custom_jql: value,
            select_template_jql: value,
          })
        );
      } else if (type === 'x-axis-field') {
        dispatch(handleAppearanceData([]));
        const type = value[0].split('.')[2];
        let newdata = { ...data };
        newdata['x-axis-field'] = value[0];
        if (type === 'assignee')
          newdata.select_template_jql = 'resolution=Unresolved';
        if (type === 'issuetype')
          newdata.select_template_jql = 'resolution=Unresolved';
        if (type === 'priority')
          newdata.select_template_jql = 'resolution=Unresolved';
        if (type === 'reporter')
          newdata.select_template_jql = 'resolution=Unresolved';
        if (type === 'status') newdata.select_template_jql = '';
        if (type === 'resolution') newdata.select_template_jql = '';

        const fields = getFields(props.fields, 'x-axis');
        newdata['x-axis-type'] = fields.find(
          (field) => field && field.value === value[0]
        );

        // if (
        //   props.report.card_template_id.key === 'custom_report' ||
        //   props.report.card_template_id.key === 'custom_report_2'
        // ) {
        let temp = '';
        // <<<< to remove  "issues" from "this.state.data['x-axis-field']" >>>>>
        newdata['x-axis-field'].split('.').forEach((str, index) => {
          if (index != 0) temp += str;
          if (
            index != 0 &&
            index != newdata['x-axis-field'].split('.').length - 1
          )
            temp += '.';
        });
        newdata.x_axis = temp;
        newdata.x_axis_type = newdata['x-axis-type'];
        setData(newdata);
        dispatch(cardInfo(newdata));
      } else if (type === 'y-axis-field') {
        let fields = getFields(props.fields, 'y-axis');
        if (value[0] == 'issues.fields.issue_count') {
          if (data.number_field && data.number_field_type) {
            data.number_field = null;
            data.number_field_type = null;
          }
        }
        data['y-axis-field'] = value[0];
        if (
          props.report.card_template_id.meta &&
          props.report.card_template_id.meta.y_axis
        ) {
          if (props.report.card_template_id.key === 'custom_report_2') {
            let temp = '';
            // <<<< to remove  "issues" from "this.state.data['x-axis-field']" >>>>>
            data['y-axis-field'].split('.').forEach((str, index) => {
              if (index != 0) temp += str;
              if (
                index != 0 &&
                index != data['y-axis-field'].split('.').length - 1
              )
                temp += '.';
            });
            data.y_axis = temp;
            // data.y_axis_type = this.state.data['x-axis-type']
            // console.log(this.state.data['y-axis-type']);
          } else data.y_axis = props.report.card_template_id.meta.y_axis;
        }

        setData({
          ...data,
          y_axis_type: fields.find((field) => field.value === value[0]),
        });
        dispatch(
          cardInfo({
            ...data,
            y_axis_type: fields.find((field) => field.value === value[0]),
          })
        );
      } else if (type === 'number-field') {
        let fields = getNumberField(props.fields, props.numberFields);

        setData({
          ...data,
          number_field: value[0],
          number_field_type: fields.find((field) => field.value === value[0]),
        });
        dispatch(
          cardInfo({
            ...data,
            number_field: value[0],
            number_field_type: fields.find((field) => field.value === value[0]),
          })
        );
      } else if (type === 'report_name') {
        const name = value.target.value;
        setData({ ...data, report_name: name });
      } else if (type === 'velocity_estimation') {
        setData({ ...data, velocity_estimation: value });
        dispatch(cardInfo({ ...data, velocity_estimation: value }));
      } else if (type === 'report_theme') {
        setData({ ...data, report_theme: value.target.value });
        // props.template.defaultValues.theme = value.target.value
      } else if (type === 'report_type') {
        setData({ ...data, report_type: value.target.value });
      } else if (type === 'mention') {
        setData({ ...data, [type]: value });
        dispatch(cardInfo({ ...data, [type]: value }));
      } else if (type === 'filterType') {
        setData({ ...data, filterType: value });
        dispatch(cardInfo({ ...data, filterType: value }));
      } else if (type === 'filterValue') {
        setData({ ...data, filterValue: value, jql: value });
        dispatch(cardInfo({ ...data, filterValue: value, jql: value }));
      } else if (type === 'estimation_field') {
        setData({ ...data, field: value });
        dispatch(cardInfo({ ...data, field: value }));
      } else {
        let newerrors = errors;

        delete newerrors[type];

        let newdata = { ...data, [type]: value };
        if (type == 'board') {
          setData(newdata);
          dispatch(cardInfo({ ...newdata }));
        }
        if (type == 'boardId') {
          // console.log("nbcijwnwjwboard")
          let board = props.boards.find((board) => board.id == value);
          // console.log("nbcijwnwjwboard",board)
          newdata.board = board;
          setData(newdata);
          dispatch(cardInfo({ ...newdata }));
        }

        setErrors({ ...newerrors });
      }
    } else {
      let errors = errors;
      delete errors[type];

      // setData({ ...data, [type]: value.target.value });
      // setErrors({ ...errors });
    }
  };

  const onChange = (value) => {
    let newdata = {
      ...data,
      filterType: value,
    };
    if (value == 'Custom JQL') {
      let info = newdata;
      info.jql = getProjectText(data, editmode);
      newdata = info;
      setJql(info.jql);
    }
    let isJqlValid = checkIsJqlValid(getProjectText(data, editmode));
    if (isJqlValid) setJqlValidated(true);
    dispatch(cardInfo(newdata));
    setData(newdata);
    setFilterType(value);
  };

  // console.log('hello', jiraSkill, props.skills, servertype);

  const chartForm = (
    <div>
      <div style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}>
        <Text strong style={{ width: '100px' }}>
          Filter Type
        </Text>
        <div>
          <Radio.Group
            onChange={(val) => onChange(val.target.value)}
            value={filterType}
          >
            <Radio.Button value='Basic Filter' name='Basic Filter'>
              Basic Filter
            </Radio.Button>
            <Radio.Button value='Custom JQL' name='Custom JQL'>
              Custom JQL
            </Radio.Button>
            {servertype && servertype === 'jira_cloud_oauth' && (
              <Radio.Button value='Jira Filter' name='Jira Filter'>
                Saved Jira Filter
              </Radio.Button>
            )}
          </Radio.Group>
        </div>
      </div>

      {filterType == 'Basic Filter' ? (
        <div
          style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Projects
          </Text>

          <Select
            mode='multiple'
            style={{ width: '100%' }}
            id='input_select_projects'
            placeholder='Select Projects'
            value={selectedProjects}
            onChange={(value) => {
              handleChange(value, 'projects');
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showArrow
          >
            {getOptions('get_projects')}
          </Select>
        </div>
      ) : filterType == 'Custom JQL' ? (
        <div style={{ display: 'flex', marginBottom: 24 }}>
          <Text strong style={{ minWidth: '100px' }}>
            Enter JQL
          </Text>
          <TextArea
            className={
              localStorage.getItem('theme') == 'dark'
                ? ' custom_text_area_dark'
                : 'custom_text_area'
            }
            style={{ width: '100%' }}
            id='Generated_jql'
            value={jql}
            placeholder='Enter value'
            onChange={(e) => {
              handleJql(e.target.value); /* setJql(value.target.value) */
              /* handleChange(value, 'custom_jql') */
            }}
            rows={
              data && data.custom_jql && data.custom_jql.length > 100 ? 4 : 2
            }
          />
          {/* {<span className='form-error'>{errors.jql}</span>} */}
        </div>
      ) : filterType == 'Jira Filter' ? (
        <div
          style={{
            display: 'flex',
            marginBottom: 24,
            alignItems: 'center',
          }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Choose Filter
          </Text>
          <Select
            style={{ width: '100%' }}
            showSearch
            allowClear
            placeholder='Choose filter'
            value={selectedFilterFromJira ? selectedFilterFromJira : null}
            onChange={(value, data) => {
              setSelectedFilterFromJira(value);
              setFilterFromJiraError(false);
              handleChange(value, 'filterValue');
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
            showArrow
          >
            {props.filterFromJira &&
              props.filterFromJira.map((filter) => (
                <Option key={filter.id} value={filter.jql} data={filter}>
                  {filter.name}
                </Option>
              ))}
          </Select>
          {filterFromJiraError && (
            <Text type='danger'>* Please select filter</Text>
          )}
        </div>
      ) : (
        <div> Please Select Filter</div>
      )}
      {filterType == 'Custom JQL' && jql && !jqlValidated && (
        <div style={{ display: 'flex', marginBottom: 24 }}>
          <div style={{ marginLeft: 100, color: 'red' }}>Invalid JQL</div>
        </div>
      )}
      <div
        style={{
          display: 'flex',
          width: '100%',
          justifyContent: 'space-around',
          alignItems: 'center',
        }}
      >
        <div style={{ minWidth: '100px' }}>
          <Text strong>Showing</Text>
        </div>
        <div
          style={{
            display: 'flex',
            rowGap: 8,
            width: '100%',
          }}
        >
          <div style={{ width: '100%', marginRight: 16 }}>
            <Select
              disabled={isFieldDisabled}
              showSearch
              autoClearSearchValue
              style={{ width: '100%' }}
              onChange={(e) => handleChange([e], 'x-axis-field')}
              placeholder='X-Axis'
              value={data && data['x-axis-field']}
              filterOption={(input, option) => {
                if (typeof option.props.children == 'string') {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                } else {
                  return (
                    option.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              }}
            >
              {getOptions('x-axis-field')}
            </Select>
          </div>
          <div style={{ width: '100%' }}>
            <Select
              disabled={isFieldDisabled}
              showSearch
              autoClearSearchValue
              style={{ width: '100%' }}
              onChange={(e) => handleChange([e], 'y-axis-field')}
              placeholder='Y-Axis'
              value={data && data['y-axis-field']}
              filterOption={(input, option) => {
                if (typeof option.props.children == 'string') {
                  return (
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                } else {
                  return (
                    option.props.label
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }
              }}
            >
              {getOptions('y-axis-field')}
            </Select>
          </div>
        </div>
      </div>
    </div>
  );

  // console.log(props.cardTemplates);

  let burnDownForm = (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}>
        <Text strong style={{ minWidth: '120px' }}>
          Select a Board
        </Text>
        <Select
          showSearch
          autoClearSearchValue
          style={{ width: '100%' }}
          value={data && data['boardId']}
          onChange={(e) => handleChange(e, 'boardId')}
          placeholder='select a board'
          name='boardId'
          loading={loadBoard}
          filterOption={(input, option) => {
            if (typeof option.props.children == 'string') {
              return (
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            } else {
              return (
                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              );
            }
          }}
        >
          {getOptions('board')}
        </Select>
      </div>

      <div style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}>
        <Text strong style={{ minWidth: '120px' }}>
          Estimation Field
        </Text>
        <Select
          showSearch
          autoClearSearchValue
          style={{ width: '100%' }}
          value={data && data['field']}
          onChange={(e) => handleChange(e, 'estimation_field')}
          placeholder='select a field'
          loading={loadBoard}
          filterOption={(input, option) => {
            if (typeof option.props.children == 'string') {
              return (
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            } else {
              return (
                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              );
            }
          }}
        >
          {getOptions('estimation_field')}
        </Select>
      </div>
    </div>
  );

  let velocityForm = (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}>
        <Text strong style={{ minWidth: '100px' }}>
          Select a Board
        </Text>
        <Select
          showSearch
          autoClearSearchValue
          style={{ width: '100%' }}
          value={data && data['boardId']}
          onChange={(e) => handleChange(e, 'boardId')}
          placeholder='select a board'
          name='boardId'
          loading={loadBoard}
          filterOption={(input, option) => {
            if (typeof option.props.children == 'string') {
              return (
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            } else {
              return (
                option.props.label.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              );
            }
          }}
        >
          {getOptions('board')}
        </Select>
      </div>

      <div style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}>
        <Text strong style={{ minWidth: '100px' }}>
          Estimation
        </Text>
        <Select
          style={{ width: '100%' }}
          value={data && data.velocity_estimation}
          onChange={(e) => handleChange(e, 'velocity_estimation')}
        >
          <Option key={'story_points'} value={'story_points'}>
            Story Points
          </Option>
          <Option
            key={'original_time_estimate'}
            value={'original_time_estimate'}
          >
            Original Time Estimate
          </Option>
          <Option key={'issue_count'} value={'issue_count'}>
            Issue Count
          </Option>
        </Select>
      </div>
    </div>
  );
  // console.log(jql);
  let listForm = (
    <div>
      <div style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}>
        <Text strong style={{ minWidth: '100px' }}>
          Filter Type
        </Text>
        <Select
          style={{ width: '100%' }}
          placeholder='Select Filter'
          value={listFilterType}
          onChange={(value) => {
            setListFilterType(value);
            setData({ ...data, listFilterType: value });
            dispatch(
              cardInfo({
                ...data,
                listFilterType: value,
                report_type: 'list',
              })
            );
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {getOptions('listFilter')}
        </Select>
      </div>

      {listFilterType === 'prebuilt_filter' ? (
        <div style={{ display: 'flex', marginBottom: 24 }}>
          <Text strong style={{ minWidth: '100px' }}>
            Choose Filter
          </Text>

          <Select
            style={{ width: '100%' }}
            value={selectedPreBuiltFilter}
            onChange={(value) => {
              setSelectedPreBuiltFilter(value);
              let jql = handleFilterJql(value);
              setData({ ...data, selectedPreBuiltFilter: value, jql: jql });
              dispatch(
                cardInfo({ ...data, selectedPreBuiltFilter: value, jql: jql })
              );
            }}
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {/* <Option value='my-open'>My open issues</Option> */}
            {/* <Option value='assgined-to-me'>Assigned to me</Option> */}
            <Option value='viewed-recent'>Viewed recently</Option>
            <Option value='created-recent'>Created recently</Option>
            <Option value='resolved-recent'>Resolved recently</Option>
            <Option value='updated-recent'>Updated recently</Option>
            <Option value='done'>Done Issues</Option>
            {/* <Option value='reported-by-me'>Reported by me</Option> */}
            {/* <Option value='watched-by-me'>Watched by me</Option> */}
            <Option value='all-open'>All Open</Option>
            <Option value='all'>All Issues</Option>
          </Select>
        </div>
      ) : listFilterType === 'custom_filter' ? (
        <div
          style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Filter
          </Text>
          <Button
            onClick={() => {
              setShowUpdateFilterModal(true);
            }}
          >
            Update Fields
          </Button>
        </div>
      ) : listFilterType === 'jql_filter' ? (
        <div style={{ display: 'flex', marginBottom: 24 }}>
          <Text strong style={{ minWidth: '100px' }}>
            Enter JQL
          </Text>
          <TextArea
            className={
              localStorage.getItem('theme') == 'dark'
                ? ' custom_text_area_dark'
                : 'custom_text_area'
            }
            style={{ width: '100%' }}
            id='Generated_jql'
            value={jql}
            placeholder='Enter value'
            onChange={(e) => handleJql(e.target.value)}
            rows={
              data && data.custom_jql && data.custom_jql.length > 100 ? 4 : 2
            }
          />
        </div>
      ) : servertype &&
        servertype === 'jira_cloud_oauth' &&
        listFilterType === 'saved_jira_filter' ? (
        <div
          style={{ display: 'flex', marginBottom: 24, alignItems: 'center' }}
        >
          <Text strong style={{ minWidth: '100px' }}>
            Jira Filter
          </Text>

          <div
            style={{
              display: 'flex',
              marginBottom: 8,
              width: '100%',
            }}
          >
            <Select
              style={{ width: '100%' }}
              showSearch
              allowClear
              placeholder='Choose filter'
              value={selectedFilterFromJira ? selectedFilterFromJira : null}
              onChange={(value, data) => {
                setSelectedFilterFromJira(value);
                setFilterFromJiraError(false);
                handleChange(value, 'filterValue');
              }}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {props.filterFromJira &&
                props.filterFromJira.map((filter) => (
                  <Option key={filter.id} value={filter.jql} data={filter}>
                    {filter.name}
                  </Option>
                ))}
            </Select>
            {filterFromJiraError && (
              <Text
                type='danger' /* style={{ marginLeft: "360px", marginTop: projectError ? "-22px" : "" }} */
              >
                * Please select filter
              </Text>
            )}
          </div>
        </div>
      ) : (
        ''
      )}
      {listFilterType === 'jql_filter' &&
        jql &&
        !jqlValidated &&
        !jqlLoading && (
          <div style={{ display: 'flex', marginBottom: 24 }}>
            <div style={{ marginLeft: 100, color: 'red' }}>Invalid JQL</div>
          </div>
        )}
    </div>
  );

  let ownerBadge = (
    <div
      style={{
        display: 'flex',
        marginBottom: 16,
        marginTop: 24,
        justifyContent: 'space-around',
        alignItems: 'center',
      }}
    >
      <Text strong style={{ minWidth: 100 }}>
        Owner
      </Text>
      <Text type='secondary' style={{ width: '100%' }}>
        Data will be loaded as{' '}
        {`${user.displayName || user.name} (${user.email})`}
      </Text>
    </div>
  );
  return (
    <div>
      {template && template.key && template.key == 'jira_burn_down_chart'
        ? burnDownForm
        : template && template.key && template.key == 'jira_velocity_chart'
        ? velocityForm
        : template && template.key && template.key == 'get_issues_by_jql'
        ? listForm
        : chartForm}

      {data && data.y_axis_type && data.y_axis_type.name != 'Issue Count' && (
        <div
          style={{
            display: 'flex',
            marginBottom: 8,
            marginTop: 24,
            justifyContent: 'space-around',
          }}
        >
          <div style={{ minWidth: '100px' }}>
            <Text strong>Grouped by</Text>
          </div>
          <Select
            showSearch
            autoClearSearchValue
            style={{ width: '100%' }}
            onChange={(e) => handleChange([e], 'number-field')}
            placeholder='Number Field'
            value={data['number_field'] ? data['number_field'] : null}
            filterOption={(input, option) => {
              if (typeof option.props.children == 'string') {
                return (
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              } else {
                return (
                  option.props.label
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                );
              }
            }}
          >
            {getOptions('number-field')}
          </Select>
        </div>
      )}
      {showUpdateFilterModal && (
        <CustomFilter
          showUpdateFilterModal={showUpdateFilterModal}
          jiraSkill={jiraSkill}
          setShowUpdateFilterModal={(data) => setShowUpdateFilterModal(data)}
          handleCustomFields={(data) => {}}
        />
      )}
      {ownerBadge}
    </div>
  );
};

// export default SourceDataOptions;
const mapStateToProps = (state) => {
  // console.log(state);
  return {
    projects: state.skills.projects,
    fields: state.skill_builder.fields,
    boards: state.skills.jiraBoards,
    currentSkill: state.skills.currentSkill,
    currentSkillUser: state.skills.currentSkillUser,
    cardSkills: state.cards.cardSkills,
    cardTemplates: state.cards.templateCards,
    report: state.report,
    skills: state.skills.skills,
  };
};
export default withRouter(
  connect(mapStateToProps, {
    getProject,
    getJiraIssueNodeFields,
    saveCard,
    updateCard,
    getJiraBoards,
    getFilterFromJira,
  })(SourceDataOptions)
);
